import React from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

export default function DefaultProjectDocumentsRow({
  documentName,
  href,
  shouldShowCoversheet,
}) {
  const { t: i18nTShared } = useTranslation('common', {
    keyPrefix: 'shared',
  });

  return (
    <tr className='hover:tw-bg-grey-025'>
      <td className='tw-border-grey-100 tw-pl-5 tw-text-m tw-font-medium tw-text-grey-900'>
        <div className='tw-flex tw-h-8 tw-items-center'>{documentName}</div>
      </td>
      <td className='tw-border-grey-100'>
        <div className='tw-flex tw-h-8 tw-items-center tw-justify-center'>
          <a
            className='tw-apply-outlined-button tw-apply-outlined-button--sm tw-apply-outlined-button--grey tw-apply-outlined-button--on-light tw-w-[68px] tw-justify-center'
            href={href}
          >
            {i18nTShared('edit')}
          </a>
        </div>
      </td>
      {shouldShowCoversheet && <td className='tw-border-grey-100' />}
    </tr>
  );
}

DefaultProjectDocumentsRow.propTypes = {
  documentName: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  shouldShowCoversheet: PropTypes.bool.isRequired,
};
